<mat-card class="content-card container-md">
  <mat-card-header>
    <mat-card-title>
      My account
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
      <div class="list-item" fxLayout="row" *ngFor="let field of accountFields">
        <app-content-row [field]="field" [entity]="accountDetails"></app-content-row>
      </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <a [disabled]="accountDetails.isTotpActive" mat-raised-button color="blue" type="button" [routerLink]="'activate-totp'">Activate Two-Factor Auth</a>
    <a mat-raised-button color="primary" type="button" [routerLink]="'change-password'">Change password</a>
  </mat-card-actions>
</mat-card>
